// extracted by mini-css-extract-plugin
export default {"container":"Mypage_container__h7bid"};